import { Body } from 'components/Typography';
import { twMerge } from 'tailwind-merge';
import { useConnection } from 'wagmi';
import { DynaVault } from '../../../../api/DynaVaultsAPI';
import { useVaultOnChainData } from 'structure/pv2/dynavault/hooks/useVaultListBlockchain';
import { getVaultPositionDisplay } from 'structure/pv2/dynavault/utils/vaultPosition';
import { UsdValue } from 'components/UsdValue';
import { AnimatedNumber } from 'structure/pv2/vault/components/AnimatedNumber';
import { VAULT_LIST_REFETCH_INTERVAL } from 'structure/pv2/dynavault/constants';

interface VaultPositionProps {
  className?: string;
  vault: DynaVault;
}

export const VaultPosition = (props: VaultPositionProps) => {
  const { className, vault } = props;

  const account = useConnection();

  const vaultOnChainData = useVaultOnChainData({
    vaultAddress: vault.address,
    chainId: vault.chainId,
    walletAddress: account.address as string,
  });
  const positionInUsd = vaultOnChainData.data?.positionInUsd ?? 0;
  const underlyingAssetDecimals =
    vaultOnChainData.data?.underlyingAssetDecimals ?? vault.decimals;

  const positionDisplay = getVaultPositionDisplay({
    underlyingAssets: vaultOnChainData.data?.walletAssets ?? BigInt(0),
    underlyingAssetDecimals,
    underlyingAssetSymbol: vaultOnChainData.data?.underlyingAssetSymbol ?? '',
    positionInUsd,
  });

  return (
    <div className={twMerge('flex flex-col items-end', className)}>
      {positionDisplay ? (
        <>
          <UsdValue size='small' value={positionInUsd} />
          <Body className='text-sm text-white-500'>
            <AnimatedNumber
              value={positionDisplay.underlyingAmount}
              decimals={Math.min(underlyingAssetDecimals, 8)}
              animationDuration={VAULT_LIST_REFETCH_INTERVAL}
            />{' '}
            {positionDisplay.underlyingAssetSymbol}
          </Body>
        </>
      ) : (
        <Body className='text-sm font-normal'>-</Body>
      )}
    </div>
  );
};
